import { render, staticRenderFns } from "./account_book_make.vue?vue&type=template&id=01e236f2"
import script from "./account_book_make.vue?vue&type=script&lang=js"
export * from "./account_book_make.vue?vue&type=script&lang=js"
import style0 from "./account_book_make.vue?vue&type=style&index=0&id=01e236f2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports